import React, { createContext, Fragment, useContext, useEffect, useReducer, useState } from 'react'
import { AuthContext } from '../../../App/App';
import axios from 'axios';
import swal from 'sweetalert';
import ModalAddAndEdit from './ModalAddAndEdit';
import jwt from 'jwt-decode'
import ModalDelete from './ModalDelete';

export const MasterContext = createContext()

function MasterAdmin() {
    const { stateAuth, dispatchAuth } = useContext(AuthContext);
    const myID = jwt(localStorage.getItem('token-helpdesk-umy')).id

    const initialState = {
        init: true,
        workunit: [],
        users: [],
        active: null,
        loadUser: false,
        modalAddAndEdit: { status: false, action: null, id: null },
        modalDelete: { status: false, id: null },
        trigger: { message: null }
    }
    const reducer = (state, action) => {
        switch (action.type) {
            case 'ACTIVE':
                return {
                    ...state,
                    active: action.active,
                    loadUser: action.loadUser,
                    users: action.users
                }
            case 'WORKUNIT':
                return {
                    ...state,
                    workunit: action.workunit,
                    init: false
                }
            case 'MODAL_ADD_EDIT':
                return {
                    ...state,
                    modalAddAndEdit: action.modalAddAndEdit
                }
            case 'MODAL_DELETE':
                return {
                    ...state,
                    modalDelete: action.modalDelete
                }
            case 'TRIGGER':
                return {
                    ...state,
                    trigger: action.trigger
                }
        }
    }
    const [state, dispatch] = useReducer(reducer, initialState)

    const getWorkUnit = () => {
        const config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'x-access-token': localStorage.getItem('token-helpdesk-umy')
            }
        }
        axios.get(`/api/v1/helpdesk/master/workunits`, config)
            .then(res => {
                dispatch({
                    type: 'WORKUNIT',
                    workunit: res.data.data
                })
            })
            .catch(err => {
                if (!err.response || err.code === 'ECONNABORTED') {
                    swal("Error!", "Check Your Internet Connection!", "error", {
                        button: "OK",
                    });
                } else if (err.response) {
                    if (err.response.data.status === 'jwt' && err.response.data.message === `TokenExpiredError`) {
                        dispatchAuth({
                            type: "LOGOUT",
                            message: 'Token expired, please login again...'
                        })
                    } else {
                        swal("Error!", `${err.response.data.message}, try agai leter!`, "error", {
                            button: "OK",
                        });
                    }
                }
            })
    }

    const handleCollapsClick = (e, id) => {
        dispatch({
            type: 'ACTIVE',
            active: (state.active === id) ? null : id,
            loadUser: (state.active == id) ? false : true,
            users: (state.active == id) ? state.users : []
        })
    }

    const handleEditUser = (e, action, id) => {
        e.preventDefault()
        dispatch({
            type: 'MODAL_ADD_EDIT',
            modalAddAndEdit: { status: true, action: action, id: id }
        })
    }

    const handleDeleteUser = (e, id) => {
        e.preventDefault()
        dispatch({
            type: 'MODAL_DELETE',
            modalDelete: { status: true, id: id }
        })
    }

    useEffect(() => {
        if (state.active != null) {
            const config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'x-access-token': localStorage.getItem('token-helpdesk-umy')
                }
            }
            axios.get(`/api/v1/helpdesk/master/users/${state.active}`, config)
                .then(res => {
                    dispatch({
                        type: 'ACTIVE',
                        active: state.active,
                        loadUser: false,
                        users: res.data.data
                    })
                })
                .catch(err => {
                    dispatch({
                        type: 'ACTIVE',
                        active: state.active,
                        loadUser: false,
                        users: state.users
                    })
                    if (!err.response || err.code === 'ECONNABORTED') {
                        swal("Error!", "Check Your Internet Connection!", "error", {
                            button: "OK",
                        });
                    } else if (err.response) {
                        if (err.response.data.status === 'jwt' && err.response.data.message === `TokenExpiredError`) {
                            dispatchAuth({
                                type: "LOGOUT",
                                message: 'Token expired, please login again...'
                            })
                        } else {
                            swal("Error!", `${err.response.data.message}, try agai leter!`, "error", {
                                button: "OK",
                            });
                        }
                    }
                })
        }
    }, [state.active])

    const [renderClients, setrenderClients] = useState(<Fragment />)
    //get client
    useEffect(() => {
        if (state.init) getWorkUnit()
    }, [state.init])

    useEffect(() => {
        if (state.workunit.length > 0 || state.trigger.message === 'reload-list') {
            setrenderClients(
                state.workunit.map(wu => (
                    <div key={wu.id} className="card mb-1" style={{ cursor: 'pointer', border: 'solid 0.5px', color: '#88888' }}>
                        <div className="card-header h-25" id={`heading${wu.id}`} style={{ backgroundColor: (wu.id == state.active) ? '#6777EF' : '#f9f9f9' }} onClick={(e) => handleCollapsClick(e, wu.id)}  >
                            <h5 className="mb-0 col-12" >
                                <p style={{ backgroundColor: 'transparent', fontWeight: 'bold' }} className={`btn btn-link ${wu.id == state.active ? 'text-white' : 'text-black'} m-0 p-1`} >
                                    {`${wu.name}${wu.acronym != null ? ` (${wu.acronym})` : ''}`}
                                </p>
                                <i className={`fas fa-chevron-circle-${wu.id == state.active ? 'down' : 'right'} float-right`} style={{ backgroundColor: 'white', fontSize: '2.em', borderRadius: '50%', border: '1px solid black', padding: '7px', cursor: 'pointer' }} ></i>
                            </h5>
                        </div>
                        {(wu.id == state.active) ?
                            <div id={`collapse${wu.id}`} style={{ backgroundColor: '#d7dbfa', color: '#000' }} aria-labelledby={`heading${wu.id}`}>
                                <div className="card-body row m-0 p-1">
                                    <div className="list-group">
                                        <div className="d-flex w-100 justify-content-between pb-2" style={{ borderBottom: 'solid 0.5px' }}>
                                            <div className="col-4 pl-4" style={{ fontWeight: 'bolder', fontSize: '1em', }}>Username</div>
                                            <div className="col-4 pl-4" style={{ fontWeight: 'bolder', fontSize: '1em' }}>Email</div>
                                            <div className="col-2" style={{ fontWeight: 'bolder', fontSize: '1em', textAlign: 'center' }}>Role</div>
                                            <div className="col-2" style={{ fontWeight: 'bolder', fontSize: '1em', textAlign: 'center' }}>Action</div>
                                        </div>
                                        {state.users.map(user => (
                                            <div key={user.id} className="d-flex w-100 justify-content-between pt-2">
                                                <div className="col-4 pl-4" style={{ fontWeight: 'normal', fontSize: '1em', }}>{user.username}</div>
                                                <div className="col-4 pl-4" style={{ fontWeight: 'normal', fontSize: '1em' }}>{user.email}</div>
                                                <div className="col-2" style={{ fontWeight: 'normal', fontSize: '1em', textAlign: 'center' }}>{user.role.name}</div>
                                                <div className="col-2" style={{ fontWeight: 'normal', fontSize: '1em', textAlign: 'center' }}>
                                                    <div className="buttons">
                                                        <button style={{ color: '#fff', textTransform: 'capitalize' }} className="btn  btn-sm btn-icon icon-left btn-primary" onClick={(e) => handleEditUser(e, 'edit', user.id)} ><i className="fas fa-edit"></i> Edit</button>
                                                        <button style={{ color: '#fff', textTransform: 'capitalize' }} className={`btn  btn-sm btn-icon icon-left btn-${user.id == myID ? 'secondary' : 'danger'}`} disabled={user.id == myID} onClick={user.id != myID ? (e) => handleDeleteUser(e, user.id) : (e) => e.preventDefault()} ><i className="fas fa-eraser"></i> Delete</button>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                            : <Fragment />}
                    </div>
                ))
            )
        }
    }, [state.workunit, state.active, state.loadUser, state.users, state.trigger])

    return (
        <Fragment>
            <div className="col-12 col-md-12 col-lg-12">
                <div className="card" style={{ minHeight: '80vh' }}>
                    <div className="card-body">
                        <div className="section-title mt-0 pb-4">
                            {stateAuth.page}
                            <p onClick={(e) => handleEditUser(e, 'add')} value="add" style={{ fontWeight: 'bold', color: '#fff', textTransform: 'capitalize', borderRadius: '25px' }} className="btn  btn-lg btn-icon icon-left btn-success float-right"><i className="fas fa-user-plus"></i> Add New User</p>
                        </div>
                        <div>
                            {renderClients}
                        </div>
                    </div>
                </div>
            </div>

            <MasterContext.Provider value={{ state, dispatch }}>
                <ModalAddAndEdit />
                <ModalDelete />
            </MasterContext.Provider>
        </Fragment>
    )
}

export default MasterAdmin